import type { ModalProps } from "antd";

export const SETTINGS_MODAL_PROPS: Partial<ModalProps> = {
  destroyOnClose: true,
  maskClosable: false,
  keyboard: false,
  centered: true,
  zIndex: 1001,
  width: "640px",
  styles: {
    content: { padding: 0, borderRadius: 12, overflow: "hidden" },
    header: {
      padding: "14px 20px 12px",
      borderBottom: "1px solid #f0f0f0",
      marginBottom: 0,
    },
    body: { padding: "16px 24px 20px" },
    footer: {
      padding: "10px 20px 14px",
      borderTop: "1px solid #f0f0f0",
      marginTop: 0,
    },
    mask: {
      position: "fixed",
      inset: 0,
      width: "100vw",
      height: "100vh",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      background: "rgba(0,0,0,0.45)",
    },
  },
};

export const CONFIRM_MODAL_PROPS = {
  maskClosable: false,
  keyboard: false,
  zIndex: 1100,
  centered: true,
};
